import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalNrichadminAdminPipelineComponent } from './portal.nrichadmin.admin.pipeline/portal.nrichadmin.admin.pipeline.component';
import { PortalNrichadminAdminDashboardComponent } from './portal.nrichadmin.admin.dashboard/portal.nrichadmin.admin.dashboard.component';
import { PortalNrichCanvasPdfComponent } from './portal.nrich.canvas.pdf/portal.nrich.canvas.pdf.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { LayoutViewerComponent } from './layout.viewer/layout.viewer.component';
import { PortalNrichChatInputComponent } from './portal.nrich.chat.input/portal.nrich.chat.input.component';
import { PortalNrichCanvasTextComponent } from './portal.nrich.canvas.text/portal.nrich.canvas.text.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalNrichDividerComponent } from './portal.nrich.divider/portal.nrich.divider.component';
import { PortalNrichChatActivityComponent } from './portal.nrich.chat.activity/portal.nrich.chat.activity.component';
import { PortalNrichadminAdminTermsComponent } from './portal.nrichadmin.admin.terms/portal.nrichadmin.admin.terms.component';
import { PortalNrichCanvasPanelComponent } from './portal.nrich.canvas.panel/portal.nrich.canvas.panel.component';
import { PortalNrichadminAdminQuerylogComponent } from './portal.nrichadmin.admin.querylog/portal.nrichadmin.admin.querylog.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalNrichCanvasThumbnailsComponent } from './portal.nrich.canvas.thumbnails/portal.nrich.canvas.thumbnails.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { LayoutPublicComponent } from './layout.public/layout.public.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PortalNrichadminAdminModelsComponent } from './portal.nrichadmin.admin.models/portal.nrichadmin.admin.models.component';
import { PortalNrichFooterComponent } from './portal.nrich.footer/portal.nrich.footer.component';
import { PortalNrichHeaderViewerComponent } from './portal.nrich.header.viewer/portal.nrich.header.viewer.component';
import { PortalNrichadminAdminVerifyComponent } from './portal.nrichadmin.admin.verify/portal.nrichadmin.admin.verify.component';
import { PageDocumentItemComponent } from './page.document.item/page.document.item.component';
import { PortalNrichNavAdminComponent } from './portal.nrich.nav.admin/portal.nrich.nav.admin.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalNrichChatPanelComponent } from './portal.nrich.chat.panel/portal.nrich.chat.panel.component';
import { PortalNrichChatMessageComponent } from './portal.nrich.chat.message/portal.nrich.chat.message.component';
import { PortalNrichadminAdminSettingsComponent } from './portal.nrichadmin.admin.settings/portal.nrichadmin.admin.settings.component';
import { PortalNrichCanvasImagesComponent } from './portal.nrich.canvas.images/portal.nrich.canvas.images.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalNrichadminAdminReviewComponent } from './portal.nrichadmin.admin.review/portal.nrichadmin.admin.review.component';
import { PortalNrichHeaderPublicComponent } from './portal.nrich.header.public/portal.nrich.header.public.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalNrichCanvasKgComponent } from './portal.nrich.canvas.kg/portal.nrich.canvas.kg.component';
import { PortalNrichadminAdminTokensComponent } from './portal.nrichadmin.admin.tokens/portal.nrichadmin.admin.tokens.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalNrichadminAdminPipelineComponent,
        PortalNrichadminAdminDashboardComponent,
        PortalNrichCanvasPdfComponent,
        PortalSeasonLoadingDefaultComponent,
        LayoutViewerComponent,
        PortalNrichChatInputComponent,
        PortalNrichCanvasTextComponent,
        LayoutEmptyComponent,
        PortalNrichDividerComponent,
        PortalNrichChatActivityComponent,
        PortalNrichadminAdminTermsComponent,
        PortalNrichCanvasPanelComponent,
        PortalNrichadminAdminQuerylogComponent,
        PageMainComponent,
        PortalNrichCanvasThumbnailsComponent,
        PortalSeasonLoadingSeasonComponent,
        PageMypageComponent,
        LayoutPublicComponent,
        LayoutAdminComponent,
        PortalNrichadminAdminModelsComponent,
        PortalNrichFooterComponent,
        PortalNrichHeaderViewerComponent,
        PortalNrichadminAdminVerifyComponent,
        PageDocumentItemComponent,
        PortalNrichNavAdminComponent,
        PortalSeasonPaginationComponent,
        PortalNrichChatPanelComponent,
        PortalNrichChatMessageComponent,
        PortalNrichadminAdminSettingsComponent,
        PortalNrichCanvasImagesComponent,
        PageLoginComponent,
        PageSearchComponent,
        PortalSeasonModalComponent,
        PageAdminComponent,
        PortalSeasonFormDropdownComponent,
        PortalNrichadminAdminReviewComponent,
        PortalNrichHeaderPublicComponent,
        PortalSeasonTreeComponent,
        PortalNrichCanvasKgComponent,
        PortalNrichadminAdminTokensComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }